import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { LicenseMonthlyServicesFormController } from '../controller/LicenseMonthlyServicesFormController';
import { FormGroupValue } from '../../../../ui/gzForm/formGroup/types/form-group-value';
import { Observable } from 'rxjs';
import { Feature, FeatureFlag } from '@nirvana/shared/constants';
import { MonthlyProductType } from '../../../types/MonthlyProductType';
import _ from 'lodash';
import { CompanyFeatures, ProductService } from '../../../../company/types/company-data';
import { CompanyLicenseInformation } from "../../../types/CompanyLicenseInformation";

export class LicenseMonthlyServicesFormWebComponent extends BaseWebComponentElement {
  public controller!: LicenseMonthlyServicesFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: LicenseMonthlyServicesFormController,
    });
  }

  public set usableProduct(usableProduct: MonthlyProductType | undefined) {
    this.controller.setUsableProduct(usableProduct);
  }

  public set availableFeatures(availableFeatures: Feature[] | undefined) {
    this.controller.setAvailableFeatures(availableFeatures);
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public set value(formValue: FormGroupValue) {
    this.controller.updateToggles(formValue as CompanyFeatures);
  }

  public get value(): FormGroupValue {
    return _.clone(this.controller.view.formGroup.value);
  }

  public set productServices(productServices: ProductService[]) {
    this.controller.setProductServices(productServices);
  }

  public set featuresInTrial(featuresInTrial: FeatureFlag[] | undefined) {
    this.controller.setFeaturesInTrial(featuresInTrial);
  }

  public set parentCompany(parentCompany: CompanyLicenseInformation['parentCompany'] | undefined) {
    this.controller.setParentCompany(parentCompany);
  }

  public isMdrSet(): boolean {
    return this.controller.view.dom.$managedDetectionAndResponseToggle.getFormValue();
  }

  public hideServices(features: FeatureFlag[]): void {
    this.controller.hideServices(features);
  }

  public setCheckedValueForServices(features: FeatureFlag[], checkedValue: boolean): void {
    this.controller.setCheckedValueForServices(features, checkedValue);
  }

  public hasServicesAvailable(): boolean {
    return this.controller.hasServicesAvailable();
  }
}
